var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ai-risk-assessment"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.loading,"disabled":_vm.disabled,"size":"mini"},on:{"click":_vm.handleAiAssess}},[_vm._v(" "+_vm._s(_vm.btnText)+" ")]),(_vm.loading)?_c('span',{staticClass:"ai-loading-text"},[_vm._v("正在AI评估中，请稍候...")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }